type PhoneNumberType = {
    href: string;
    displayValue: string;
};

export const utcSourcePhoneMap: Record<string, PhoneNumberType> = {
    google: {
        href: '14158399974',
        displayValue: '415-839-9974',
    },
    'google/organic': {
        href: '14158399974',
        displayValue: '415-839-9974',
    },
    'google/cpc': {
        href: '14159412342',
        displayValue: '415-941-2342',
    },
    bing: {
        href: '14157380721',
        displayValue: '415-738-0721',
    },
    'bing/organic': {
        href: '14157380721',
        displayValue: '415-738-0721',
    },
    'bing/cpc': {
        href: '14153909217',
        displayValue: '415-390-9217',
    },
    fb: {
        href: '14159698310',
        displayValue: '415-969-8310',
    },
    TikTok: {
        href: '14158135385',
        displayValue: '415-813-5385',
    },
    mediaalpha: {
        href: '14153909240',
        displayValue: '415-390-9240',
    },
    quinstreet: {
        href: '14158131711',
        displayValue: '415-813-1711',
    },
};

export const partnerOfferIdPhoneMap: Record<string, PhoneNumberType> = {
    '8': {
        href: '14153909250',
        displayValue: '415-390-9250',
    },
    '17': {
        href: '14153909187',
        displayValue: '415-390-9187',
    },
    '18': {
        href: '14153909208',
        displayValue: '415-390-9208',
    },
    '19': {
        href: '14158131711',
        displayValue: '415-813-1711',
    },
    '20': {
        href: '14158397860',
        displayValue: '415-839-7860',
    },
};
